import { ROUTES as RoutesDTO } from "@/dto";

export const Routes: RoutesDTO = {
  thisApp: "https://arcontroller-web.onrender.com", //
  remoteApi: "https://api-publica.onrender.com/", //
  // local: ,"https://arcontroller-web.onrender.com/", // "https://arcontroller-web.vercel.app/", //
  // localAPI: ,"https://api-publica.onrender.com/", //,
  Dashboard: "/Dashboard",
};
